import styled from 'styled-components'
import {
  COLOR
} from '../../../themes'
const Style = styled.div`
  #floorLayoutImage{
    width: 100%;
    object-fit: contain;
  }
  height: 100%;
  p {
    text-align: center;
    position: relative;
    top: calc(50vh - 160px);
    color: ${COLOR.GRAY_10}
  }
  `

export default Style
